export const CategoriesMap = {
  IGNORE: 'ignore',
  DRUG: 'drug',
  VACCINATIONS: 'Vaccinations',
  VACCINE: 'vaccine',
  FOOD: 'food',
  SUPPLY: 'supply',
  UNMATCHED: 'unmatched',
  PROCEDURE: 'procedure',
  LAB: 'lab',
  DIAGNOSIS: 'diagnosis'
};

export const CategoriesLabelsMap = {
  [CategoriesMap.IGNORE]: 'Ignore',
  [CategoriesMap.DRUG]: 'Drug',
  [CategoriesMap.VACCINATIONS]: 'Vaccinations',
  [CategoriesMap.VACCINE]: 'Vaccine',
  [CategoriesMap.FOOD]: 'Food',
  [CategoriesMap.SUPPLY]: 'Supply',
  [CategoriesMap.UNMATCHED]: 'Unmatched',
  [CategoriesMap.PROCEDURE]: 'Procedure',
  [CategoriesMap.LAB]: 'Lab',
  [CategoriesMap.DIAGNOSIS]: 'Diagnosis'
};
